import { DateTime } from 'luxon';

// QuickBooks journal numbers hold at most 21 characters. RoboDebit numbers them
// PREFIX_00001, so "_" plus five digits leaves 15 for the prefix.
export const PREFIX_MIN = 4;
export const PREFIX_MAX = 15;
export const RATE_LIMIT = 10000;

const RATE_PATTERN = /^-?\d{1,5}(?:\.\d{1,3})?$/;

// On an edit, a value still matching the saved one passes, so templates made under
// older rules stay editable. The server applies the same rules.

export const prefixRule = (saved?: string) => (value: string) => {
  const text = (value || '').trim();
  if (saved !== undefined && text === saved.trim()) return true;
  return (text.length >= PREFIX_MIN && text.length <= PREFIX_MAX) || `${PREFIX_MIN}-${PREFIX_MAX} characters`;
};

export const rateRule = (saved?: string) => (value: string) => {
  const text = (value || '').trim();
  if (saved !== undefined && text === saved.trim()) return true;
  return (
    (RATE_PATTERN.test(text) && Math.abs(Number(text)) <= RATE_LIMIT) ||
    'Between -10,000 and 10,000, up to 3 decimals'
  );
};

export const todayIn = (timezone?: string) => DateTime.now().setZone(timezone || 'UTC').startOf('day');

export const startDateRule = (timezone?: string, saved?: DateTime | null) => (value: DateTime | null) => {
  if (!value) return 'Date is required';
  if (typeof value === 'string' || !value.isValid) return 'Please enter a valid date';
  const zone = timezone || 'UTC';
  const day = value.setZone(zone).toISODate();
  if (saved && saved.isValid && day === saved.setZone(zone).toISODate()) return true;
  return day! >= todayIn(zone).toISODate()! || 'Start date cannot be in the past';
};
